import { Skeleton } from '../../Skeleton'
import { CalendarView } from '../CalendarView'

import * as styles from './CalendarTasksView.module.css'

function CalendarTasksView({ isLoading, preferences, onChangePreferences }) {
  function handleChangeMode(viewMode) {
    onChangePreferences({ view_mode: viewMode })
  }

  return isLoading ? (
    <Skeleton className={styles.skeleton} />
  ) : (
    <CalendarView
      initialMode={preferences.view_mode}
      onChangeMode={handleChangeMode}
    />
  )
}

export default CalendarTasksView
